import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Nav, Navbar } from "react-bootstrap";
import { BoxArrowRight, BoxSeam, Envelope, ListCheck, RocketTakeoffFill, Truck } from 'react-bootstrap-icons';
import { Link } from "react-router-dom";


export default function Home(props: any) {


    return (
        <div>
            <Navbar expand="lg" >
                <Container fluid>
                    <Navbar.Brand as={Link} to={'/'}>
                        <div className='d-flex align-items-center'>
                            <Truck size={30} className="text-primary me-1" />
                            MDF-e
                        </div>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            <Nav.Link className='text-uppercase' as={Link} to={"/recursos"}>
                                <div className='d-flex align-items-center'>
                                    <ListCheck size={20} className="text-primary me-1" />
                                    Recursos
                                </div>
                            </Nav.Link>
                            <Nav.Link className='text-uppercase' as={Link} to={'/planos'}>
                                <div className='d-flex align-items-center'>
                                    <BoxSeam size={20} className="text-primary me-1" />
                                    Planos
                                </div>
                            </Nav.Link>
                            <Nav.Link className='text-uppercase' as={Link} to={'/contato'}>
                                <div className='d-flex align-items-center'>

                                    <Envelope size={20} className="text-primary me-1" />
                                    Contato
                                </div>
                            </Nav.Link>
                            <Nav.Link className='text-uppercase' as={Link} to={'/login'}>
                                <div className='d-flex align-items-center'>

                                    <BoxArrowRight size={20} className="text-primary me-1" />
                                    Login
                                </div>
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <section className=" text-center py-3   ">
                <Container>

                    {props.children === undefined ? (
                        <>
                            <h1 className="display-4 fw-bold">Gerencie seus MDF-e de forma simples</h1>
                            <p className="lead mt-3">
                                Emita, cancele e acompanhe seus Manifestos Eletrônicos de Documentos Fiscais com rapidez e segurança.
                            </p>
                            <Link to={'/register'} className="btn btn-primary"><RocketTakeoffFill className="me-2" />Assine agora</Link>
                        </>
                    ) : (
                        props.children
                    )}
                </Container>
            </section>
            <footer
                className={`fixed-bottom d-flex justify-content-between pb-1 pe-1 px-2 bg-light`}>
                <div>
                    © {new Date().getFullYear().toString()} PlugSystem | Todos os direitos reservados.
                </div>



            </footer>
        </div>
    );
}
